module.exports = __webpack_public_path__ + "img/aParty_121223_A.d0b410d8.jpg";